module["exports"] = ["0##-########", "0###-########", "1##########"];